import React, { useState } from 'react';
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";


const SignupForm = (props) => {
  let apiUrl = '/';

    if(process.env.REACT_APP_ENVIRONMENT == 'local'){
         apiUrl = process.env.REACT_APP_SERVER_API_URL;
    }

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${apiUrl}api/users/signup`, formData);
      toast.success("Signup successful! Welcome aboard.");
      navigate('/account/signin');
    } catch (error) {
      setIsLoading(false);
      toast.error("Error registering user");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signup-section" style={{ marginTop: "20px" }}>
      <div className="container">
        <div className="row align-items-center">
         
          <div className="col-lg-6 d-none d-lg-block">
            <img
              src="../assets/img/sign-up.jpg"
              alt="Signup Illustration"
              className="img-fluid rounded"
              style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}
            />
          </div>

        
          <div className="col-lg-6">
            <div className="form-card p-4 shadow rounded bg-white">
              <h2 className="text-center mb-4">Create Your Account</h2>
              <p className="text-center text-muted mb-4">
                Join us to experience a world of possibilities!
              </p>
              <form type="POST" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    name="name"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    name="password"
                    id="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={isLoading}
                >
                  {isLoading ? "Signing Up..." : "Sign Up"}
                </button>
                <p className="text-center mt-3">
                  Already have an account?{" "}
                  <Link to="/account/signin">Sign In</Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
